<template>
  <div class="row {{ perpendicularAlignmentClass }}">
    <div class="col-3">{{ label }}</div>
    <div class="col text-black text-cursor" @click.prevent.stop>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MappedItemDetailsRow',
  props: {
    perpendicularAlignmentClass: {
      type: String,
      default: 'items-center',
    },
    label: {
      required: true,
      type: String,
    },
  },
};
</script>
